import React from "react";

export default function SchedulingEmptyState({
  iconSrc,
  title,
  description,
  action,
  className = "",
}) {
  return (
    <output className={`scheduling-empty-state ${className}`.trim()}>
      {iconSrc && (
        <span className="scheduling-empty-state-icon" aria-hidden>
          <img src={iconSrc} alt="" />
        </span>
      )}
      {title && <p className="scheduling-empty-state-title">{title}</p>}
      {description && (
        <p className="scheduling-empty-state-desc">{description}</p>
      )}
      {action && <div className="scheduling-empty-state-action">{action}</div>}
    </output>
  );
}
